module.exports = __webpack_public_path__ + "static/media/SOTA COMET VI.4ede258d.png";